import {
  type LiveVoiceStatus,
  type LiveVoiceToken,
  parseLiveVoiceStatus,
  parseLiveVoiceToken,
} from "./live-voice";
import { rpc } from "./rpc";

type LiveVoiceInput = { voiceId?: string };

function liveMethod(name: "status" | "token"): ((input?: LiveVoiceInput) => unknown) | null {
  let live: unknown;
  try {
    live = Reflect.get(rpc, "live");
  } catch {
    return null;
  }
  if ((typeof live !== "object" && typeof live !== "function") || live === null) return null;
  const method = Reflect.get(live, name);
  if (typeof method !== "function") return null;
  return (input) => Reflect.apply(method, live, input ? [input] : []);
}

/**
 * The live RPC lands in a parallel change. Read it at runtime so this branch
 * builds before and independently of the contract merge; an absent endpoint is
 * treated as "feature not available".
 */
export async function loadLiveStatus(voiceId?: string): Promise<LiveVoiceStatus | null> {
  const invoke = liveMethod("status");
  if (!invoke) return null;
  const value: unknown = await invoke(voiceId ? { voiceId } : undefined);
  return parseLiveVoiceStatus(value);
}

/** Single-use ephemeral token. It is kept only in memory and never logged. */
export async function requestLiveToken(voiceId?: string): Promise<LiveVoiceToken | null> {
  const invoke = liveMethod("token");
  if (!invoke) return null;
  const value: unknown = await invoke(voiceId ? { voiceId } : undefined);
  return parseLiveVoiceToken(value);
}
